import { useMemo } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { useTheme } from "@fluentui/react/lib/Theme";

const classNames = {
  button: `RelevanceActionButton`
};

export function useRelevanceActionButtonStyles() {
  const { semanticColors } = useTheme();
  const styleSet = useMemo(
    () => mergeStyleSets({
      button: [
        classNames.button,
        {
          color: semanticColors.inputFocusBorderAlt
        }
      ]
    }),
    [semanticColors]
  );

  return styleSet;
}
